import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import NextPage from './NextPage';

function NextPageContent({ ...restProps }) {
    return (
        <NextPage to="/contact" text="" {...restProps}>
            Contactez nous <FontAwesomeIcon icon={faArrowRight} />
        </NextPage>
    );
}

export default NextPageContent;
